export enum DeclineReasons {
  FailedEmailVerification = 'Failed Email Verification',
  FailedPhoneVerification = 'Failed Phone Verification',
  Abandon = 'Abandon',
  RefiAbandon = 'Refi Abandon',
  RefiScore = 'Refi Score',
  SummitLead = 'Summit Lead',
  PotentialFraud = 'Potential Fraud',
  WithdrawnApplication = 'Withdrawn Application',
  RefiInvalidState = 'Refi Invalid State',
}
